import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const divisionsTableTooltips = TOOLTIPS_TEXTS.chatsTable;

export const CHATS_OPTIONS: TableOption[] = [
  { action: 'view', src: 'icons/reply' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const ARCHIVED_CHATS_OPTIONS: TableOption[] = [
  { action: 'view', src: 'icons/green-eye' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const CHATS_TABLE_CONFIG: TableSource = {
  displayedColumns: [
    'updatedAt',
    'divisionName',
    'communityName',
    'address',
    'contactName',
    'buyerName',
    'options'
  ],
  displayedTitles: [
    'Updated',
    'Division',
    'Community',
    'Home Address',
    'Contact',
    'Buyer',
    'Actions'
  ],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    divisionsTableTooltips.updatedAt,
    divisionsTableTooltips.division,
    divisionsTableTooltips.community,
    divisionsTableTooltips.address,
    divisionsTableTooltips.contactName,
    divisionsTableTooltips.buyer
  ],
  optionsPerRow: null,
  options: null,
  dataSource: []
};
